import Vue from 'vue'
import Router from 'vue-router'
import { ROUTE_PATHS } from '@/constants/routes'
import { tokenStorage } from '@/utils/storage'

// 导入页面组件
import Login from '@/views/auth/Login'
import GoodsList from '@/views/goods/GoodsList'
import GoodsAdd from '@/views/goods/GoodsAdd'
import GoodsEdit from '@/views/goods/GoodsEdit'
import GoodsDetail from '@/views/goods/GoodsDetail'
import GoodsView from '@/views/goods/GoodsView'
import UserManagement from '@/views/user/UserManagement'
import LiveCenter from '@/views/live/LiveCenter'
import MemoCenter from '@/views/memo/MemoCenter'
import FileCenter from '@/views/file/FileCenter'
import InventoryCenter from '@/views/inventory/InventoryCenter'
import TokenDebug from '@/components/TokenDebug'

// 保留原有组件（用于兼容）
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/search'
    },
    {
      path: ROUTE_PATHS.LOGIN,
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: ROUTE_PATHS.SEARCH,
      name: 'Search',
      component: GoodsList,
      meta: { requiresAuth: true, title: '商品查询' }
    },
    {
      path: ROUTE_PATHS.ADD,
      name: 'Add',
      component: GoodsAdd,
      meta: { requiresAuth: true, title: '添加商品' }
    },
    {
      path: ROUTE_PATHS.LIVE,
      name: 'Live',
      component: LiveCenter,
      meta: { requiresAuth: true, title: '直播中心' }
    },
    {
      path: ROUTE_PATHS.USER_MANAGEMENT,
      name: 'UserManageMent',
      component: UserManagement,
      meta: { requiresAuth: true, title: '用户管理' }
    },
    {
      path: ROUTE_PATHS.UPDATE,
      name: 'Update',
      component: GoodsEdit,
      meta: { requiresAuth: true, title: '更新商品' }
    },
    {
      path: ROUTE_PATHS.SHOW,
      name: 'Show',
      component: GoodsDetail,
      meta: { requiresAuth: true, title: '商品详情' }
    },
    {
      path: ROUTE_PATHS.MEMO,
      name: 'Memo',
      component: MemoCenter,
      meta: { requiresAuth: true, title: '备忘中心' }
    },
    {
      path: ROUTE_PATHS.FILE,
      name: 'File',
      component: FileCenter,
      meta: { requiresAuth: true, title: '文件中心' }
    },
    {
      path: ROUTE_PATHS.HELLO_WORLD,
      name: 'HelloWorld',
      component: HelloWorld,
      meta: { requiresAuth: true, title: 'Hello World' }
    },
    {
      path: ROUTE_PATHS.INVENTORY,
      name: 'Inventory',
      component: InventoryCenter,
      meta: { requiresAuth: true, title: '盘货中心' }
    },
    {
      path: ROUTE_PATHS.DETAIL,
      name: 'Detail',
      component: GoodsView,
      meta: { requiresAuth: true, title: '商品详情' }
    },
    {
      path: '/debug',
      name: 'Debug',
      component: TokenDebug,
      meta: { requiresAuth: false, title: 'Token调试' }
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} - Zac的小仓库`
  }

  // 检查是否需要认证
  if (to.meta && to.meta.requiresAuth !== false) {
    const token = tokenStorage.getToken()
    console.log('路由守卫 - 当前token:', token) // 调试用
    console.log('路由守卫 - token长度:', token ? token.length : 0) // 调试用

    if (!token || token.trim() === '') {
      console.log('没有有效token，跳转到登录页')
      next({
        path: ROUTE_PATHS.LOGIN,
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js